import { render, staticRenderFns } from "./FinishedContainer.vue?vue&type=template&id=048e3280&"
import script from "./FinishedContainer.vue?vue&type=script&lang=js&"
export * from "./FinishedContainer.vue?vue&type=script&lang=js&"
import style0 from "./FinishedContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VContainer,VOverlay})
